/** 肝脏病学 */

/** 对应的标题 */
const categoryMap = {
  LilleModel: 'Lille模型',
  Alanine_Aminotransferase: '丙氨酸氨基转移酶（ALT）',
  Unsaturated_Iron_Binding_Capacity: '不饱和铁结合力（UIBC）',
  Chloride: '氯化物',
  TBIL: '总胆红素',
  DBIL: '直接胆红素',
  Cholinesterase: '胆碱酯酶',
  Proline: '脯氨酸',
  Glutamate_Dehydrogenase: '谷氨酸脱氢酶（GLDH）',
  Fibrinogen: '纤维蛋白原',
  Prealbumin: '前白蛋白（PA）',
  Cystatin_C: '胱抑素C（Cys C）',
  Alkaline_Phosphatase: '碱性磷酸酶（ALP）',
  Gamma_Glutamyl_Transferase: 'γ-谷氨酰转肽酶（GGT）',
  a1_antitrypsin: 'α1-抗胰蛋白酶（α1-AT）'
}
/** 对应的描述 */
const categoryDescMap = {
  LilleModel: '严重酒精性肝病预后评分'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Hepatology.js